import { useSnapshot } from 'valtio'
import { uiState } from '../data'
import { AnimatePresence, motion } from 'framer-motion'
import { isMobile } from 'react-device-detect'
import { useEffect, useRef } from 'react'
import { windowSizeState } from '../utils/windowSize'
import { sourcePath } from '../utils/path.js'

const Intro = ({ event }) => {
  const { visible, pcContent, phContent } = useSnapshot(uiState[event])
  const { phoneMode } = useSnapshot(windowSizeState)
  const closeHandler = () => {
    sessionStorage.clear()
    uiState.music.isMusicPlaying = true
    uiState.homepage.visible = true
    uiState[event].visible = false
  }

  return (
    <>
      {visible && (
        <div className='fixed top-0 left-0 screen-setting bg-black z-[99] justify-center items-center hidden landscapePhone:flex'>
          <div className=' w-[60%] aspect-[1/0.53] NotoSansB text-[20px] flex  justify-center items-center border-[3px] border-white p-[30px] rounded-[30px]'>
            <div className='w-[calc(100%-210px)] mr-[25px]'>
              <img
                src='../startImages/animated.png'
                alt='橫幅手機提示'
                className='w-full object-contain'
              />
            </div>
            <div className='text-white  w-[140px] '>
              <div>
                請以<span className=' text-mainOrage-100'>直式</span>
              </div>
              <div>繼續瀏覽網頁</div>
            </div>
          </div>
        </div>
      )}
      {visible && <div className='screen-setting bg-bgColor-100'></div>}
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            className='fixed top-0 left-0 screen-setting bg-bgColor-100   '
            onClick={closeHandler}
          >
            <div className=' flex whitespace-pre-wrap  items-center justify-center absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full p-2 '>
              <img
                src='../startImages/music_tips.png'
                alt='耳機示意圖'
                className='w-[80px] object-contain mr-[45px] portraitBigPh:w-[55px]  portraitBigPh:mr-[20px]'
                onMouseEnter={() => {
                  uiState.mouseStyle.showOrangeSpot = false
                }}
                onMouseLeave={() => {
                  uiState.mouseStyle.showOrangeSpot = true
                }}
              />
              <div
                onMouseEnter={() => {
                  uiState.mouseStyle.showOrangeSpot = false
                }}
                onMouseLeave={() => {
                  uiState.mouseStyle.showOrangeSpot = true
                }}
              >
                <div className='NotoSansB text-[26px] portraitBigPh:text-[18px] leading-[34px] mb-1 portraitBigPh:leading-[24px] '>
                  {phoneMode ? phContent.zh : pcContent.zh}
                </div>
                <div className='NotoSansB text-[16px] tracking-[1px] portraitBigPh:text-[12px]'>
                  {phoneMode ? phContent.en : pcContent.en}
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

export default Intro
